var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('Haendlersuche',{attrs:{"points":_vm.points,"abhData":_vm.abhData,"translation":_vm.instance.translation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }